import React from "react";
import { Layout } from "antd";

export default function Footer() {
   const { Footer } = Layout;
   return (
      <Footer>
         <p>&#169; 2022 Created By Rikky Agung Nugraha</p>
      </Footer>
   );
}
